import React, { useRef } from "react"
// import { useScrollPercentage } from "react-scroll-percentage"
import { useDraggable } from "react-use-draggable-scroll"
import "./styles.scss"
import SectionHeader from "../../molecules/SectionHeader"
import TabsVertical from "../../molecules/TabsVertical"
import TLink from "../../transitions/TLink"

const HowWeWork = ({ title, subtitle, icons }) => {
  // const [ref, percentage] = useScrollPercentage({
  //   rootMargin: "10px 0px 0px 0px",
  // })
  // const scrollerRef = useRef(null)

  const ref = useRef() // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref)

  return (
    <section className="section section--howWeWork">
      <div className="section__sticky">
        <div className="wrapper--text">
          <SectionHeader
            attributes={{
              "data-sal": "slide-up",
              "data-sal-duration": "1000",
              "data-sal-easing": "ease",
            }}
            type="h2"
            subtitle={subtitle}
          >
            {title}
          </SectionHeader>
        </div>
        <div className="wrapper--text spacer" {...events} ref={ref}>
          <div className="scroller">
            <div
              className="scroller__inner"
              // style={{
              //   transform: `translateX(-${
              //     percentage * 1.2 * scrollerRef?.current?.offsetWidth - 750
              //   }px)`,
              // }}
            >
              <div className="scroller__items">
                {icons.map(icon => (
                  <div className="icon">
                    <span
                      className="icon__svg"
                      dangerouslySetInnerHTML={{ __html: icon.svgCode }}
                    ></span>
                    <h2 className="icon__title">{icon.title}</h2>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="wrapper--text wrapper--footer">
          <div class="text__wrapper">
            <h3 className="title">Learn more about our process</h3>
          </div>
          <TLink className={`btn btn--bordered`} to="/approach">
            Process
          </TLink>
        </div>
      </div>
    </section>
  )
}
export default HowWeWork
